export default __webpack_public_path__ + "static/media/user-statistics.49bd3972.svg";